"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreButton = exports.RelatedMovies = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var RelatedMovieEpisode_1 = require("./RelatedMovieEpisode");
var getRelatedMovies = function (_a) {
    var movies = _a.movies, activeIndex = _a.activeIndex, viewAll = _a.viewAll;
    if (activeIndex === -1)
        return [];
    if (viewAll)
        return movies;
    switch (true) {
        case activeIndex < 2:
            return movies.slice(0, 6);
        case activeIndex > movies.length - 2:
            return movies.slice(-5);
        default:
            return movies.slice(activeIndex - 2, activeIndex + 4);
    }
};
var RelatedMovies = function (props) {
    var movies = props.movies;
    var _a = (0, react_1.useState)(movies.length <= 5 || false), viewAll = _a[0], setViewAll = _a[1];
    var activeIndex = movies.findIndex(function (movie) { return movie.active; });
    if (!movies.length)
        return null;
    var relatedMovies = getRelatedMovies({ movies: movies, activeIndex: activeIndex, viewAll: viewAll });
    var title = "Episodes (".concat(movies.length, ")");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h3", null, title),
        relatedMovies.map(function (movie) { return (react_1.default.createElement(RelatedMovieEpisode_1.RelatedMovieEpisode, __assign({ key: movie.UUID }, movie))); }),
        !viewAll && (react_1.default.createElement(exports.ShowMoreButton, { className: (0, classnames_1.default)({ detached: activeIndex === movies.length - 1 }), onClick: function () { return setViewAll(true); } },
            react_1.default.createElement("span", { className: "btn btn-default clickable" }, "View All")))));
};
exports.RelatedMovies = RelatedMovies;
exports.ShowMoreButton = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px 0;\n  background: ", ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &.detached {\n    position: relative;\n    height: 50px;\n  }\n"], ["\n  padding: 10px 0;\n  background: ", ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &.detached {\n    position: relative;\n    height: 50px;\n  }\n"])), function (props) {
    return "linear-gradient(\n      to bottom,\n      rgba(0,0,0,0) 0% 0%,\n      ".concat(props.theme.primary1, " 50%,\n      ").concat(props.theme.primary1, " 100%\n    )");
});
exports.default = exports.RelatedMovies;
var templateObject_1;
